import React from 'react';
import { VaultFilesEmptyStateIcon } from '../../assets/icons';
import {
    VaultInitialEmptyStateContent,
    VaultInitialEmptyStateSubtitle,
    VaultInitialEmptyStateTitle,
    VaultInitialEmptyStateVisual,
    VaultInitialEmptyStateWrapper,
} from './VaultInitialEmptyState.styles';

export const VaultInitialEmptyState = () => {
    return (
        <VaultInitialEmptyStateWrapper>
            <VaultInitialEmptyStateContent>
                <VaultInitialEmptyStateVisual>
                    <VaultFilesEmptyStateIcon />
                </VaultInitialEmptyStateVisual>

                <VaultInitialEmptyStateTitle>
                    Your Complete Document <br /> Management Center
                </VaultInitialEmptyStateTitle>

                <VaultInitialEmptyStateSubtitle>
                Let AI automatically organize, analyze, and convert <br /> your financial documents into portfolio data.
                </VaultInitialEmptyStateSubtitle>

            </VaultInitialEmptyStateContent>
        </VaultInitialEmptyStateWrapper>
    );
}; 